import request from '@/utils/request'

export function add(data) {
    return request({
        url: 'api/carInspectionOrder/create',
        method: 'post',
        data
    })
}

export function byId(params) {
    return request({
        url: 'api/carInspectionOrder/getById',
        method: 'get',
        params
    })
}

export function getByPage(params) {
    return request({
        url: 'api/carInspectionOrder',
        method: 'get',
        params
    })
}

export function edit(data) {
    return request({
        url: 'api/carInspectionOrder',
        method: 'put',
        data
    })
}

export function del(id) {
    return request({
        url: 'api/carInspectionOrder',
        method: 'delete',
        params: id
    })
}

export function refund(data) {
    return request({
        url: 'api/carInspectionOrder/refund',
        method: 'post',
        data
    })
}

export function toPay(data) {
    return request({
        url: 'api/carInspectionOrder/toPay',
        method: 'post',
        data
    })
}

export function addUserRemark(data) {
    return request({
        url: 'api/carInspectionOrder/addUserRemark',
        method: 'post',
        data
    })
}
export default {add, byId, getByPage, edit, del, refund, toPay, addUserRemark}
